// Helper function to get technology icon path
export const getTechIcon = (techName: string) => {
  const techIconMap: Record<string, string> = {
    Python: '/images/projects/Python.svg',
    TensorFlow: '/images/projects/TensorFlow.svg',
    FastAPI: '/images/projects/fastAPI.svg',
    React: '/images/projects/react.svg',
    PostgreSQL: '/images/projects/PostgreSQL.svg',
    Redis: '/images/projects/redis.svg',
    NodeJS: '/images/projects/NodeJS.svg',
    TypeScript: '/images/projects/typescript.svg',
    JavaScript: '/images/projects/javascript.svg',
    NextJS: '/images/projects/next-js.svg',
    VueJS: '/images/projects/vue.svg',
    Angular: '/images/projects/angular.svg',
    Docker: '/images/projects/Docker.svg',
    MongoDB: '/images/projects/MongoDB.svg',
    MySQL: '/images/projects/mysql.svg',
    Git: '/images/projects/git.svg',
    GitHub: '/images/projects/github.svg',
    GSAP: '/images/projects/gsap.svg',
    CSS: '/images/projects/css.svg',
    HTML: '/images/projects/html.svg',
    Vite: '/images/projects/vite.svg',
    ThreeJS: '/images/projects/threejs.svg',
    Cypress: '/images/projects/cypress.svg',
    Jest: '/images/projects/jest.svg',
    'VS Code': '/images/projects/vsCode.svg',
    'Framer Motion': '/images/projects/framer.svg',
    PyTorch: '/images/projects/PyTorch.svg',
    n8n: '/images/projects/n8n.svg',
    Claude: '/images/projects/claude.svg',
    Stripe: '/images/projects/stripe.svg',
    TailwindCSS: '/images/projects/tailwind.svg',
    Tailwind: '/images/projects/tailwind.svg',
    ChartJS: '/images/projects/chartjs.svg',
    Clerk: '/images/projects/Clerk.svg',
    AI: '/images/projects/ai.svg',
    Firebase: '/images/projects/firebase.svg',
    Prisma: '/images/projects/prisma.svg',
    Supabase: '/images/projects/supabase.svg',
  };

  return techIconMap[techName] || null;
};
